import { Notify } from 'quasar';

interface Config {
  message: string,
  color?: string,
  icon?: string,
  textColor?: string,
  badgeColor?: string,
  timeout?: number,
}

function notify(config: Config) {
  const { message } = config;
  return Notify.create(Object.assign({
    message,
    color: 'white',
    textColor: 'black',
    position: 'bottom-right',
    timeout: 3000,
  }, config));
}

export default {
  success(message: string) {
    const config: Config = {
      message,
      icon: 'fa fa-check-circle text-positive',
      badgeColor: 'positive',
    };
    notify(config);
  },
  failure(message: string) {
    const config: Config = {
      message,
      icon: 'fa fa-times-circle text-negative',
      badgeColor: 'negative',
    };
    notify(config);
  },
};
